export default __webpack_public_path__ + "static/media/calendar-arrow-previous.f6f3bea8.svg";